import { api } from './client';
import type { ApiKey, ApiKeyCreated } from '@/types';

export function listApiKeys(): Promise<ApiKey[]> {
  return api<ApiKey[]>('/api/keys');
}

export function createApiKey(body: { name: string; scopes: string[] }): Promise<ApiKeyCreated> {
  return api<ApiKeyCreated>('/api/keys', { method: 'POST', body });
}

export function revokeApiKey(id: string): Promise<void> {
  return api<void>(`/api/keys/${id}`, { method: 'DELETE' });
}
